import React from 'react';
import Logo from '../../assets/Logo.png';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-3">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        {/* Logo and Address */}
        <div className="flex items-center mb-6 md:mb-0">
          <img src={Logo} alt="SAN Engineering Solutions" className="w-16 h-16 mr-4" />
          <div className="text-sm leading-relaxed">
            <h3 className="text-lg font-bold">Team Tech Roofings</h3>
            <p>
              19, 5th, Cross,<br/>
              Villankurichi Rd, Thaneerpanthal,<br/>
              Coimbatore, Tamil Nadu 641035
            </p>
          </div>
        </div>
        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
          <ul className="space-y-1">
            <li>
              <a href="/" className="hover:text-gray-400 transition-colors text-sm">
                Home
              </a>
            </li>
            <li>
              <a href="/enquire" className="hover:text-gray-400 transition-colors text-sm">
              Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* Copyright */}
      <div className="mt-6 text-center text-xs text-gray-500">
        &copy; {new Date().getFullYear()} Team Tech Roofing. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;